export default "__VITE_ASSET__a57792ee__"